import {
  BasicQuality,
  PremiumQuality,
  ProQuality,
  AIGenerated,
  Designer,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { QUALITY_LEVEL, CONTENT_SOURCE } from 'Pods/SearchPage/Store/constants'

export const qualityLevels = [
  { value: QUALITY_LEVEL.ANY, labelKey: 'any' },
  { value: QUALITY_LEVEL.BASIC, labelKey: 'basic', icon: BasicQuality },
  { value: QUALITY_LEVEL.PREMIUM, labelKey: 'premium', icon: PremiumQuality },
  { value: QUALITY_LEVEL.PRO, labelKey: 'pro', icon: ProQuality },
]

export const contentSources = [
  { value: CONTENT_SOURCE.ALL, labelKey: 'all' },
  { value: CONTENT_SOURCE.AI_GENERATED, labelKey: 'ai_generated', icon: AIGenerated },
  { value: CONTENT_SOURCE.HUMAN_CREATED, labelKey: 'human_created', icon: Designer },
]
